import { Button } from "components/Button";
import { SMALL } from "shared/variables";
import { StarRating } from "components/StarRating";
import styles from "./ReviewsSummaryBar.module.css";

export const ReviewsSummaryBar = ({ amount, rating, type, uid }) => {
  const linkType =
    type === "course_detail" ? "course_reviews_form" : "training_reviews_form";

  return (
    <div className={styles.container}>
      <div className={styles.ratingContainer}>
        <StarRating rating={rating} />
        <div>
          <span className={styles.rating}>{Math.round((rating * 2) * 10) / 10}</span> •{" "}
          {amount === 1 ? `${amount} review` : `${amount} reviews`}
        </div>
      </div>
      <Button size={SMALL} link={{ type: linkType, uid }}>
        Schrijf een review
      </Button>
    </div>
  );
};
